var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ol",
      { staticClass: "breadcrumb breadcrumb-quirk" },
      _vm._l(_vm.breadcrumblist, function(bread, index) {
        return _c(
          "li",
          {
            key: index,
            class: { active: index === _vm.breadcrumblist.length - 1 }
          },
          [
            index !== _vm.breadcrumblist.length - 1
              ? [
                  _c(
                    "router-link",
                    { attrs: { to: { name: bread.pathName } } },
                    [
                      _c("i", { class: [bread.icon] }),
                      _vm._v(" " + _vm._s(bread.name) + "\n                ")
                    ]
                  )
                ]
              : _vm._e(),
            index === _vm.breadcrumblist.length - 1
              ? [
                  _c("i", { class: [bread.icon] }),
                  _vm._v(" " + _vm._s(bread.name) + "\n            ")
                ]
              : _vm._e()
          ],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }